import "@/App.css";
import "leaflet/dist/leaflet.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { InstanceProvider } from "@/context/InstanceContext";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Scoreboard from "@/pages/Scoreboard";
import Heatmap from "@/pages/Heatmap";
import LiveMap from "@/pages/LiveMap";

function App() {
  return (
    <BrowserRouter>
      <InstanceProvider>
        <AppLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/scoreboard" element={<Scoreboard />} />
            <Route path="/heatmap" element={<Heatmap />} />
            <Route path="/livemap" element={<LiveMap />} />
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </AppLayout>
      </InstanceProvider>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
